module.exports = __webpack_public_path__ + "img/img-board.e73a852e.svg";